// Copyright (c) Konnecta Systems. All rights reserved.
// Licensed under the Custom License. See LICENSE file in the project root for full license information.
// This was autogenerated by zAppDev.
import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class ParticipantWorkAssignment  {
    _originalTypeClassName = "Loom.BO.ParticipantWorkAssignment";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
ParticipantWorkAssignment.translate = translateService;
}
this.NeededCompetencies = [];
this.Id = null;
this.IsLeader = false;
this.Effort = null;
this.OrderIndex = null;
this.LumpSumCosts = null;
this.WorkType = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
IsLeader:any;
Effort:any;
OrderIndex:any;
LumpSumCosts:any;
WorkType:any;
WorkPackage:any;
Task:any;
Participant:any;
Project:any;
NeededCompetencies:any;
static setWorkPackage = ($this, value) => {
var oldValue = $this.WorkPackage;
$this.WorkPackage = value;
if (value != null) {
if (oldValue != null) {
Domain.WorkPackage.removeParticipations(oldValue, $this);
}
Domain.WorkPackage.addParticipations(value, $this);
}
}
static setTask = ($this, value) => {
var oldValue = $this.Task;
$this.Task = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectTask.removeAssignments(oldValue, $this);
}
Domain.ProjectTask.addAssignments(value, $this);
}
}
static setParticipant = ($this, value) => {
var oldValue = $this.Participant;
$this.Participant = value;
if (value != null) {
if (oldValue != null) {
Domain.ProjectParticipant.removeWorkAssignments(oldValue, $this);
}
Domain.ProjectParticipant.addWorkAssignments(value, $this);
}
}
static setProject = ($this, value) => {
var oldValue = $this.Project;
$this.Project = value;
if (value != null) {
}
}
static setNeededCompetencies = ($this, items) => {
                if (items == null) items = [];
                if ($this.NeededCompetencies == null) $this.NeededCompetencies = [];

                const copyItems = Common.cloneObject(items);

                while ($this.NeededCompetencies.length > 0) {
                    Domain.ParticipantWorkAssignment.removeNeededCompetencies($this, $this.NeededCompetencies[0]);
                }

                Domain.ParticipantWorkAssignment.addManyNeededCompetencies($this, copyItems);
            }
static addManyNeededCompetencies = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.ParticipantWorkAssignment.addNeededCompetencies($this, items[i]);
                }
            }
static addNeededCompetencies = ($this, item) => {
                if ($this.NeededCompetencies == null) $this.NeededCompetencies = [];
                if (item == null || $this.NeededCompetencies.indexOf(item) > -1) return;
                $this.NeededCompetencies.push(item);
}
static addRangeNeededCompetencies = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.ParticipantWorkAssignment.addNeededCompetencies($this, item));
            }
static removeNeededCompetencies = ($this, item) => {
                if ($this == null || $this.NeededCompetencies == null || $this.NeededCompetencies.indexOf(item) === -1) return;
                var _index = $this.NeededCompetencies.indexOf(item);
                $this.NeededCompetencies.splice(_index, 1);
}
static clearNeededCompetencies = ($this) => { $this.NeededCompetencies = null; }

static GetOrderIndex($this: any): any{return $this?.Participant?.ParticipantNumberDecimal;
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}